import Vue from 'vue';
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/themes/material_green.css';

Vue.component('FlatPickr', FlatPickr);

export default FlatPickr;
